import axios from 'axios';

const API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://gsanv2.siinsan.gob.gt/api'   
    : 'http://localhost:5148/api';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        const username = parsedUser.username || parsedUser.Username;
        if (username) {
          config.headers['X-Audit-User'] = username;
        }
      }
    } catch (e) {
      console.error("Error leyendo usuario para auditoría:", e);
    }

    console.log(`[Axios] ${config.method.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;